//export const apiPort = "3000"
//export const apiRoot = "https://speechserver.experts7.com:" + apiPort + "/"

// Runtime settings come from /config.js (generated at container start, see docker-entrypoint.sh); the values below are the dev fallback
const runtimeConfig = (typeof window !== "undefined" && window.__VOXDOC_CONFIG__) || {}

export const apiPort = runtimeConfig.apiPort || "3000"
export const apiRoot = runtimeConfig.apiRoot || "https://api.test1.experts7.com/"
export const server = runtimeConfig.server || "testServer 1"
